import startsWith from 'lodash/startsWith';
import React from 'react';
import getLocale from '../../helpers/getLocale';
import PolicyEn from './PolicyEn';
import PolicyEs from './PolicyEs';

function PrivacyPolicy() {
  if (startsWith(getLocale(), 'es')) {
    return <PolicyEs />;
  }

  return <PolicyEn />;
}

export default PrivacyPolicy;
